import { errorUtil } from '@cmg/common';
import React from 'react';

import type { Account } from '../../../../types/domain/account/account';
import { useFetchAccount } from './useFetchFirm';

export const useRemapAccountsState = ({
  currentAccountSubdomain,
}: {
  currentAccountSubdomain: string;
}) => {
  const [accounts, setAccounts] = React.useState<Account[]>([]);
  const [accountError, setAccountError] = React.useState<string | null>(null);
  const {
    fetchAccountByCmgEntityKey: fetchAccountByCmgEntityKeyCall,
    fetchAccountBySubdomain: fetchAccountBySubdomainCall,
    fetchFirmByCmgEntityKey,
    loading,
  } = useFetchAccount();

  const fetchAccountByCmgEntityKey = React.useCallback(
    async (cmgEntityKey: string) => {
      try {
        return await fetchAccountByCmgEntityKeyCall(cmgEntityKey);
      } catch (error) {
        // @ts-expect-error
        errorUtil.assertIsError(error);
        // @ts-expect-error
        const { message } = error;
        setAccountError(message);
      }
    },
    [setAccountError, fetchAccountByCmgEntityKeyCall]
  );

  const fetchAccountBySubdomain = React.useCallback(
    async (subdomain: string) => {
      try {
        const account = await fetchAccountBySubdomainCall(subdomain);
        setAccounts(accs => {
          const accounts = [...(accs ?? []), account];
          return [...new Map(accounts.map(item => [item?.subdomain, item])).values()];
        });
        return account;
      } catch (error) {
        // @ts-expect-error
        errorUtil.assertIsError(error);
        // @ts-expect-error
        const { message } = error;
        setAccountError(message);
      }
      return undefined;
    },
    [fetchAccountBySubdomainCall, setAccountError, setAccounts]
  );

  React.useEffect(() => {
    void fetchAccountBySubdomain(currentAccountSubdomain);
  }, [currentAccountSubdomain, fetchAccountBySubdomain]);

  return {
    accounts,
    accountError,
    loadingAccount: loading,
    fetchAccountByCmgEntityKey,
    fetchFirmByCmgEntityKey,
  };
};
